import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { VoucherService } from '@app/modules/core/services/vouchers/vouchers.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';



@Component({
  selector: 'bkg-summary-vouchers',
  templateUrl: './summary-vouchers.component.html',
  styleUrls: ['./summary-vouchers.component.scss'],
  providers: [DatePipe]
})
export class SummaryVouchersComponent implements OnInit, OnDestroy {

  @Input() vouchers: any;

  @Output() addVoucherCodeReturn = new EventEmitter<string>();
  private destroy$ = new Subject<void>();

  selectedVoucherCode: string | null = null;

  constructor(
    private voucherService: VoucherService,
    private router: Router
  ) { }


  ngOnInit(): void {
    this.voucherService.selectedVoucherCode$
      .pipe(takeUntil(this.destroy$))
      .subscribe((code) => {
        this.selectedVoucherCode = code;
      });
  }


  onCouponSelected(code: string): void {
    if (this.selectedVoucherCode === code) return;
    this.selectedVoucherCode = code;
    this.voucherService.setSelectedVoucherCode(code);
    this.addVoucherCodeReturn.emit(this.selectedVoucherCode);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  get collapseByVoucherSelected() {
    const currentUrl = this.router.url;

    if (currentUrl.includes('/products')) return false;

    if ((currentUrl.includes('/services') || currentUrl.includes('/traveler-data')) && this.selectedVoucherCode && this.vouchers) {
      return true
    }

    return false
  }
}
